module.exports = __webpack_public_path__ + "static/media/pagination-right.13716dcc.svg";